import React from 'react';
import { items } from './Auth/InfoNPolicies';

const TermsNConditions = ({ index }) => {
  return (
    <div className="policies_css">{items[index ?? 3].children}</div>
  );
};

export default TermsNConditions;